import { render } from "./worker-ftag.vue?vue&type=template&id=01114664"
import script from "./worker-ftag.vue?vue&type=script&lang=js"
export * from "./worker-ftag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__